export default __webpack_public_path__ + "static/media/ic_suriname.1e82700a.svg";